//TRIGGER FUNCTIONS ON WINDOW RESIZE

var onResize = function(event){

    if(studioCarousel.length > 0 && !studioCarousel.hasClass('.slick-initialized') && window.innerWidth > 991){

        studioCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {

            studioSelector.removeClass('active').eq(nextSlide).addClass('active');

            $(e.target).find('.slick-active .text').addClass('hide');

        });

        studioCarousel.on('init afterChange', function (e, slick, currentSlide) {

            setTimeout(function () {
                $(e.target).find('.slick-active .text').removeClass('hide');
            }, 1000);

        });

        studioSlickArgs.initialSlide = studioSelector.index(studioSelector.parent().find('.active'));

        //console.log('Init SLick');

        studioCarousel.not('.slick-initialized').slick(studioSlickArgs);
    }

    if(serviceCarousel.length > 0 && !serviceCarousel.hasClass('.slick-initialized') && window.innerWidth > 991){

        serviceCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {

            serviceSelector.removeClass('active').eq(nextSlide).addClass('active');

            $(e.target).find('.slick-active .text').addClass('hide');

        });

        serviceCarousel.on('init afterChange', function (e, slick, currentSlide) {

            setTimeout(function () {
                $(e.target).find('.slick-active .text').removeClass('hide');
            }, 1000);

        });

        serviceSlickArgs.initialSlide = serviceSelector.index(serviceSelector.parent().find('.active'));

        //console.log('Init SLick');

        serviceCarousel.not('.slick-initialized').slick(serviceSlickArgs);
    }

    if(window.innerWidth > 991) {
        // $('body').removeClass('fixed menu-active');
    }

    var priceTable = $('.prices table'),
        soonElem = priceTable.siblings('.soon'),
        soonColumns = soonElem.data('columns'),
        bgColumns = priceTable.find('.discount-bg');

    if(priceTable.length > 0 && parseInt(soonColumns) > 0) {
        var cells = priceTable.find('tr').eq(0).find('th').slice(parseInt(soonColumns) * -1);

        var width = 0;

        for(a=0; a<cells.length; a++){
            width += cells.eq(a).outerWidth();
        }

        soonElem.css('width', width);
    }

    if(priceTable.length > 0 && bgColumns.length > 0) {
        var bgHeight = 0;

        var rows = priceTable.find('tr').not(':first').not(':last');

        for(var a=0; a<rows.length; a++){
            var row = rows.eq(a);

            bgHeight += row.outerHeight();
        }

        bgColumns.css('height', bgHeight);
    }

    onScroll();
};

$(window).on('resize orientationchange', onResize);